import { useQuery } from '@tanstack/react-query';
import { Contestant } from '../types/contestant';
import { fetchContestantByCode } from '../services/contestantService';

export const useContestantByCode = (code?: string) => {
  return useQuery<Contestant>({
    queryKey: ['contestant', 'code', code],
    queryFn: () => fetchContestantByCode(code!),
    enabled: !!code,
  });
};